import OfferMockups from './OfferMockups'

export default OfferMockups
